import { useState } from 'react';

import { ImpactCo2AnswerStatsPublic } from '@/domain/impact-stats/entities/stats-public.entity';

import { ExtrapolationColors } from '../utils/extrapolation-colors';

export function useExtrapolation(
  statsPublic: ImpactCo2AnswerStatsPublic,
  personCount: number,
  applyFn: (
    stats: ImpactCo2AnswerStatsPublic,
    factor: number,
  ) => ImpactCo2AnswerStatsPublic,
) {
  const [extrapolationValue, setExtrapolationValue] = useState('');

  const target = parseInt(extrapolationValue, 10);
  const factor = target > 0 && personCount > 0 ? target / personCount : null;
  const isExtrapolationActive = factor !== null;

  const statsPublicOverride = isExtrapolationActive
    ? applyFn(statsPublic, factor)
    : statsPublic;

  const isHighFactor = factor !== null && factor > 10;

  const valueColor = isExtrapolationActive
    ? ExtrapolationColors.overrideValue
    : undefined;

  return {
    extrapolationValue,
    setExtrapolationValue,
    isExtrapolationActive,
    statsPublicOverride,
    isHighFactor,
    valueColor,
  };
}
